module.exports = __webpack_public_path__ + "static/sport/gallery-thumbs3.83c4bce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/gallery-thumbs3.jpg
// module id = CSij
// module chunks = 0